import React from 'react';
import cx from 'classnames';
import cs from '../index.module.scss';

const AcademyIcon: React.FC<any> = ({ className, ...restProps }) => (
  <span className={cx(cs.container, className)} {...restProps}>
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34 18C34 26.8366 26.8366 34 18 34C9.16344 34 2 26.8366 2 18C2 9.16344 9.16344 2 18 2C26.8366 2 34 9.16344 34 18ZM36 18C36 27.9411 27.9411 36 18 36C8.05887 36 0 27.9411 0 18C0 8.05887 8.05887 0 18 0C27.9411 0 36 8.05887 36 18ZM12 10C10.8954 10 10 10.8954 10 12V19C10 20.1046 10.8954 21 12 21H15V24C15 25.1046 15.8954 26 17 26H24C25.1046 26 26 25.1046 26 24V17C26 15.8954 25.1046 15 24 15H21V12C21 10.8954 20.1046 10 19 10H12ZM21 15V21H15V15H21ZM19 17H17V19H19V17Z"
        fill="#ED0070"
      />
    </svg>
  </span>
);

export default AcademyIcon;
